import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const articleTypeApi = generateNomenApi(`/nomen/article-type`);

export const articleTypeOptions = generateNomenOptions('article-type', articleTypeApi);
